import React from "react";
import moment from "moment";
import "moment/locale/es";

import { sanitize } from "dompurify";

const SurveySplashCarouselWelcome = ({ survey, welcome }) => {
  const { name, expiryDate } = survey;
  const { text, videoUrl } = welcome;

  const formattedExpiryDate =
    expiryDate && moment(expiryDate, "YYYY-MM-DD").format("DD [de] MMMM [de] YYYY");

  return (
    <>
      <h1 className="postcard__title blue">{name ?? "Encuesta"}</h1>
      {formattedExpiryDate && (
        <div
          className="postcard__subtitle font-weight-bold d-flex align-items-center"
          style={{ fontSize: "20px" }}
        >
          <i className="fas fa-calendar-alt mr-2"></i>Finaliza el {formattedExpiryDate}
        </div>
      )}
      <div className="postcard__bar"></div>
      {text ? (
        <div dangerouslySetInnerHTML={{ __html: sanitize(text, { ADD_ATTR: ["target"] }) }}></div>
      ) : (
        <span>texto de bienvenida</span>
      )}
      <div className="text-center my-4">
        {videoUrl && (
          <iframe
            title="Bienvenida encuesta"
            src={videoUrl}
            width="600"
            height="337"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          />
        )}
      </div>
    </>
  );
};

export default SurveySplashCarouselWelcome;
